import React from 'react';
import { faChargingStation } from '@fortawesome/pro-regular-svg-icons/faChargingStation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ChargingStationRegularIcon(props) {
  return <FontAwesomeIcon icon={faChargingStation} {...props} />;
}
